import { rootNamespace } from "config";
import { onDeleteKey, onEscKey } from "lib/helpers";
import { forwardRef, useContext, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { TreeContext } from "pages/Editor";

function FramePortal({ children, title, onLoad, ...props }, ref) {
  // really stylesheets loaded
  const [ready, setReady] = useState(0);
  const { selection, editable, publish } = useContext(TreeContext);
  const onReady = (e) => {
    if (e.target !== ref.current) return;
    setReady(ready + 1);
    if (onLoad) onLoad(e);
  };

  useEffect(() => {
    const listener = (e) => {
      onEscKey(() => {
        if (selection) publish(rootNamespace, "SELECT", selection.path);
      })(e);
      onDeleteKey(() => {
        if (selection) publish(rootNamespace, "REMOVE", selection.path);
      })(e);
    };
    if (editable) {
      const document = ref.current.contentDocument;
      document.addEventListener("keydown", listener);
      return () => document.removeEventListener("keydown", listener);
    }
  }, [editable, publish, selection, ref]);
  return (
    <iframe src="/iframe.html" {...{ ref, title, onLoad: onReady }} {...props}>
      {ready > 0 && createPortal(children[0], ref.current.contentDocument.head)}
      {ready > 0 && createPortal(children[1], ref.current.contentDocument.body)}
    </iframe>
  );
}

export default forwardRef(FramePortal);
